export default __webpack_public_path__ + "static/media/512.e5322b90.png";